















import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'PaginationReviews',
  props: {
    label: {
      type: [String, Number],
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isArrowButton: {
      type: Boolean,
      default: false,
    },
  },
});
